module.exports = __webpack_public_path__ + "static/software-27e8e7a5c600c504f3e3c98b9b44e5a3.png";